export const changes = [
    {
        version: "14.0",
        date: "28/08/2026",
        key: "v14_0"
    },
    {
        version: "13.0",
        date: "27/06/2026",
        key: "v13_0"
    },
    {
        version: "12.0",
        date: "25/05/2026",
        key: "v12_0"
    },
    {
        version: "11.0",
        date: "23/04/2026",
        key: "v11_0"
    },
    {
        version: "10.0",
        date: "17/02/2026",
        key: "v10_0"
    },
    {
        version: "9.0",
        date: "02/02/2026",
        key: "v9_0"
    },
    {
        version: "8.0",
        date: "18/01/2026",
        key: "v8_0"
    },
    {
        version: "7.0.3",
        date: "12/01/2026",
        key: "v7_0_3"
    },
    {
        version: "7.0.2",
        date: "11/01/2026",
        key: "v7_0_2"
    },
    {
        version: "7.0.1",
        date: "09/01/2026",
        key: "v7_0_1"
    },
    {
        version: "7.0",
        date: "08/01/2026",
        key: "v7_0"
    },
    {
        version: "6.0.2",
        date: "03/01/2026",
        key: "v6_0_2"
    },
    {
        version: "6.0.1",
        date: "31/12/2025",
        key: "v6_0_1"
    },
    {
        version: "6.0",
        date: "26/12/2025",
        key: "v6_0"
    },
    {
        version: "5.0.2",
        date: "08/11/2025",
        key: "v5_0_2"
    },
    {
        version: "5.0.1",
        date: "07/11/2025",
        key: "v5_0_1"
    },
    {
        version: "5.0",
        date: "05/11/2025",
        key: "v5_0"
    },
    {
        version: "4.10.9",
        date: "30/10/2025",
        key: "v4_10_9"
    },
    {
        version: "4.10.8",
        date: "29/10/2025",
        key: "v4_10_8"
    },
    {
        version: "4.10.7",
        date: "28/10/2025",
        key: "v4_10_7"
    },
    {
        version: "4.10.6",
        date: "24/10/2025",
        key: "v4_10_6"
    },
    {
        version: "4.10.5",
        date: "20/10/2025",
        key: "v4_10_5"
    },
    {
        version: "4.10.4",
        date: "18/10/2025",
        key: "v4_10_4"
    },
    {
        version: "4.10.3",
        date: "18/10/2025",
        key: "v4_10_3"
    },
    {
        version: "4.10.2",
        date: "17/10/2025",
        key: "v4_10_2"
    },
    {
        version: "4.10.1",
        date: "16/10/2025",
        key: "v4_10_1"
    },
    {
        version: "4.10.0",
        date: "14/10/2025",
        key: "v4_10_0"
    },
    {
        version: "4.9.9.9",
        date: "10/10/2025",
        key: "v4_9_9_9"
    },
    {
        version: "4.9.9.8",
        date: "07/10/2025",
        key: "v4_9_9_8"
    },
    {
        version: "4.9.9.7",
        date: "06/10/2025",
        key: "v4_9_9_7"
    },
    {
        version: "4.9.9.6",
        date: "03/10/2025",
        key: "v4_9_9_6"
    },
    {
        version: "4.9.9.5",
        date: "02/10/2025",
        key: "v4_9_9_5"
    },
    {
        version: "4.9.9.2",
        date: "25/09/2025",
        key: "v4_9_9_2"
    },
    {
        version: "4.9.9.1",
        date: "23/09/2025",
        key: "v4_9_9_1"
    }
];
